import React from "react";
import Footer from "../Components/Footers/Footer";
import Header from "../Components/Headers/Header";
import image_stans from "../assests/images/airportc1.png";
import image_stans2 from "../assests/images/airport-c2.png";
import "../assests/css/StanstedAirport.css";
import { Link } from "react-router-dom";

const StanstedAirport = () => {
  const handleBooking = () => {
    // window.location.replace("https://eb3.autocab.net/#/33710");
    window.open("https://eb3.autocab.net/#/33710", "_blank");
  };
  return (
    <div className="stanstedairport">
      <section className="bg-privacy-policy-top mb-3">
        <Header />
        <div className="container px-5">
          <div className="row px-3">
            <div className="col-lg-12 my-4 text-center">
              <p className="text-white f-72 my-5 f-pop-med">
                Stansted Airport Taxis
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="Stansted ">
        <div className="container  my-5">
          <div className="row my-5">
            <div className="col-lg-6 my-3 align-self-center">
              <p className="df-clr f-20 f-pop-med">Stansted Airport</p>
              <p className="f-25 f-pop-med mb-4">Arrival</p>
              <p className="clr-77 f-14 f-pop-reg mb-5">
                We do offer a Meet & Greet service at your request outside
                arrivals, It has a shopping service, which contributes to making
                shopping much more convenient, it has a prayer and smoking area
                as well. These facilities are installed just to make travelling
                easy. Stansted airport serves more than 160 destinations across
                Europe, Asia, and Africa. The new arrival is being planned so
                travellers will not have to wait in large immigration queues,
                and there will be an extensive baggage claim area.
              </p>
              {/* <Link to="/booking" className='link_ourfleet'>
                                <button className='btn btn-danger bt-aboutus f-14 f-pop-reg'>Book Now</button>
                            </Link> */}
              <a className="link_ourfleet">
                <button
                  className="btn btn-danger bt-aboutus f-14 f-pop-reg"
                  onClick={handleBooking}
                >
                  Book Now
                </button>
              </a>
            </div>
            <div className="col-lg-6 my-3 text-end">
              <img src={image_stans} className="wdth-100" alt="airport image" />
            </div>
            <div className="col-lg-6 my-5">
              <img
                src={image_stans2}
                className="wdth-100"
                alt="airport image"
              />
            </div>
            <div className="col-lg-6 align-self-center text-end my-5 my-res-stanstedairport">
              <p className="df-clr f-20 f-pop-med">Stansted Airport</p>
              <p className="f-25 f-pop-med mb-4">Departures</p>
              <p className="clr-77 f-14 f-pop-reg mb-5">
                If you have book a return journey with us our you will receive
                an SMS on the day with your drivers information who will be
                ready and waiting to bring you back to Airport departures London
                Stansted Airport is close to M11 Motorway, which is really
                amazing because you would not have to wait in traffic. It is
                imperative, especially when you are getting late and you do not
                want to miss your flight. It has one terminal without any gates
                and 3 satellite terminals with gates. For your convenience, it
                has an automated people mover (APM), it connects terminal
                satellite 1 and terminal satellite 2 to the main terminal
                building.
              </p>
              {/* <Link to="/booking" className="link_ourfleet">
                <button className="btn btn-danger bt-aboutus f-14 f-pop-reg">
                  Book Now
                </button>
              </Link> */}
              <a className="link_ourfleet">
                <button
                  className="btn btn-danger bt-aboutus f-14 f-pop-reg"
                  onClick={handleBooking}
                >
                  Book Now
                </button>
              </a>
            </div>
          </div>
        </div>
        <section className="red_airport_ftr pos-rel">
          <div className="container ">
            <div className="row">
              <div className="col-lg-6 py-5">
                <p className="f-45 f-pop-semibold text-white mb-3 mt-5">
                  Book A Cab Online
                </p>
                <p className="f-14 f-pop-reg text-white lh-02">
                  Curabitur placerat cursus nisi nec pharetra. Proin quis tortor
                  fringilla, placerat nisi nec, auctor ex. Donec commodo orci ac
                  lectus mattis
                </p>
                {/* <Link to="/booking" className="link_ourfleet">
                  <button className="btn btn-danger f-14 bt-aboutus clr-white-btn-book f-pop-med mt-3 mb-5">
                    Book Now
                  </button>
                </Link> */}
                <a className="link_ourfleet">
                  <button
                    className="btn btn-danger f-14 bt-aboutus clr-white-btn-book f-pop-med mt-3 mb-5"
                    onClick={handleBooking}
                  >
                    Book Now
                  </button>
                </a>
              </div>
              <div className="col-lg-6 text-end">
                <div className="bg-van-btm"></div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default StanstedAirport;
